import React from "react";
import Login from "../../../Components/Auth/Login";
import "./Login.scss";

const LoginPage = () => {
  return (
    <div className="login-page">
      <Login />
    </div>
  );
};

export default LoginPage;
